import { graphql } from "@/config/graphql";
import { logger } from "@/utils/logger";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  AppBar,
  Box,
  Skeleton,
  Toolbar,
  Typography,
  styled,
} from "@mui/material";
import { Link } from "react-router-dom";
import { getReadableDate, getWeekDayName } from "@/utils/date";

import { ReportStepper } from "@/components/ReportStepper";

const Body = styled("div")<{ bigHeader?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 30px;
  margin: auto;
  max-width: 1200px;
  ${(props) =>
    props.bigHeader
      ? `margin-top: 170px;
  min-height: calc(100vh - 170px);
  ${props.theme.breakpoints.up(600)} {
    margin-top: 178px;
    min-height: calc(100vh - 178px);
  }

  ${props.theme.breakpoints.up(0)} @media (orientation: landscape) {
    margin-top: 162px;
    min-height: calc(100vh - 162px);
  }`
      : `margin-top: 56px;
  min-height: calc(100vh - 56px);
  ${props.theme.breakpoints.up(600)} {
    margin-top: 64px;
    min-height: calc(100vh - 64px);
  }

  ${props.theme.breakpoints.up(0)} @media (orientation: landscape) {
    margin-top: 48px;
    min-height: calc(100vh - 48px);
  }`}
`;
const currentReportQuery = graphql(`
  query currentReport($params: ReportParams!) {
    currentUser {
      id
      selectedPlant {
        plant {
          id
          name
        }
      }
    }
    report(params: $params) {
      id
      status
      date
    }
  }
`);

export const ReportFormLayout = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { data, loading } = useQuery(currentReportQuery, {
    variables: {
      params: {
        id: +(params?.id || 0),
      },
    },
  });

  const location = useLocation();
  useEffect(
    function goHomeIfNoReport() {
      if (!loading && (!data?.report || data.report.status !== "DRAFT")) {
        logger.warn({
          msg: "No report or report is not draft",
          report: data?.report,
        });
        navigate("/");
      }
    },
    [data?.report, loading, navigate]
  );
  const reportDate = data?.report?.date
    ? new Date(
        +new Date(data.report.date) + new Date().getTimezoneOffset() * 60 * 1000
      )
    : undefined;
  return (
    <Body
      bigHeader={
        location.pathname.includes("formulario-reporte") &&
        !location.pathname.includes("resumen")
      }
    >
      <AppBar position="fixed">
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" component="div" sx={{ lineHeight: 1.1 }}>
              {loading ? (
                <Skeleton width={120} sx={{ bgcolor: "white", opacity: 0.5 }} />
              ) : (
                data?.currentUser?.selectedPlant?.plant?.name
              )}
            </Typography>
            <Typography
              variant="subtitle1"
              component="div"
              sx={{ lineHeight: 1.1 }}
            >
              {loading ? (
                <Skeleton width={150} sx={{ bgcolor: "white", opacity: 0.5 }} />
              ) : (
                `${getWeekDayName(reportDate)} ${getReadableDate(reportDate)}`
              )}
            </Typography>
          </Box>

          <Link to={"/"}>
            <img src={"/logo.png"} alt="logo" />
          </Link>
        </Toolbar>
        <ReportStepper />
      </AppBar>
      <Outlet />
    </Body>
  );
};
